import { jsxs } from "react/jsx-runtime";
import { Html } from "@react-three/drei";
import { fontFamily } from "./index219.js";
import { indexToLetter } from "./index220.js";
const BuildingName = ({ building }) => {
  return /* @__PURE__ */ jsxs(Html, { center: true, style: {
    pointerEvents: "none",
    padding: "2px 8px",
    borderRadius: "4px",
    background: "#0D0E0F",
    color: "#fff",
    fontFamily,
    fontSize: 14
  }, children: [
    "Block ",
    indexToLetter(building.data.index)
  ] });
};
export {
  BuildingName
};
//# sourceMappingURL=index169.js.map
